// extracted by mini-css-extract-plugin
export default {"container":"components-Shared-List-styles__container--h2e9F","item":"components-Shared-List-styles__item--GtHPx"};